import axios from 'axios';
import config from '../config';
import { OnboardDevicesOnlinePeersResponse } from '../interfaces';

export const getOnboardDevicesOnlinePeers = (): Promise<OnboardDevicesOnlinePeersResponse> => {
    return axios.get(`${config.API_URL}/onboard-devices/peers/online`).then((response: any) => {
        const payload = response.data?.data || response.data || {};

        return {
            vpn_server_main: Array.isArray(payload.vpn_server_main) ? payload.vpn_server_main : [],
            vpn_server_secondary: Array.isArray(payload.vpn_server_secondary)
                ? payload.vpn_server_secondary
                : [],
        };
    });
};
